import { useItemSet } from '@exam-management/common/item-set-provider';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import {
  EDITABLE_ITEM_SET_QUESTION_DETAILS_STATUSES,
  PREVIEWABLE_ITEM_SET_STATUSES,
} from '@exam-management/qcontent-management';
import { Button, VisibilityOutlinedIcon } from '@shared/components';
import { useDisclosure } from '@shared/hooks';
import { useHasPermission } from '@shared/permissions';

import FormItemSetQuestionPreviewModal from '../form-item-set-question-preview-modal/form-item-set-question-preview-modal';
import { ItemSetQuestionPreviewModal } from '../item-set-question-preview-modal';

export default function ItemSetQuestionPreviewButton() {
  const { itemSet } = useItemSet();
  const [isPreviewModalOpen, { close: closePreviewModal, open: openPreviewModal }] =
    useDisclosure(false);
  const [isFormPreviewModalOpen, { close: closeFormPreviewModal, open: openFormPreviewModal }] =
    useDisclosure(false);

  const hasUpdatePermission = useHasPermission(APP_PERMISSIONS.QBANK.QUESTION.UPDATE);
  const shouldDisablePreview =
    !PREVIEWABLE_ITEM_SET_STATUSES.includes(itemSet.status) || !itemSet.totalQuestions;
  const isEditable =
    EDITABLE_ITEM_SET_QUESTION_DETAILS_STATUSES.includes(itemSet.status) && hasUpdatePermission;

  const handleClick = () => {
    if (isEditable) return openFormPreviewModal();

    return openPreviewModal();
  };

  return (
    <>
      <Button
        color='secondary'
        variant='outlined'
        startIcon={<VisibilityOutlinedIcon />}
        disabled={shouldDisablePreview}
        onClick={handleClick}
      >
        Preview Question
      </Button>
      {!shouldDisablePreview ? (
        <>
          <ItemSetQuestionPreviewModal open={isPreviewModalOpen} onClose={closePreviewModal} />
          <FormItemSetQuestionPreviewModal
            open={isFormPreviewModalOpen}
            onClose={closeFormPreviewModal}
          />
        </>
      ) : null}
    </>
  );
}
